import { FC } from "react";
import { Icon } from "../../atoms";
import styles from './benefit.module.scss';

export type BenefitProps = {
  text: string;
};

export const Benefit: FC<BenefitProps> = ({text}) => {
  return (
    <div className={styles.benefit}>
      <div className={styles.iconWrapper}>
        <Icon icon='check' size={'22px'} />
      </div>
      <div className={styles.benefitText}>
        {text}
      </div>
    </div>
  );
}